import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import Masonry from 'react-responsive-masonry'

import editIcon from 'images/icons/editWhite.svg'

import iconAdd from './i/add.png'
import iconRemove from './i/remove.png'

import { isTagsExistId } from './utils'

import styles from './ListView.module.scss'

const MarkList = ({ tag, isChildren = false }) => {
    if (!tag.isSystem && !tag.isInterests) return null

    return (
        <ul className={classNames(styles.marksList, { [styles.isChildrenMarksList]: isChildren })}>
            {tag.isSystem && <li className={classNames(styles.mark, styles.isSystemMark)} title="System tag" />}
            {tag.isInterests && (
                <li className={classNames(styles.mark, styles.isInterestsMark)} title="Interests tag" />
            )}
        </ul>
    )
}

const Item = ({ tag, selectedTags = [], onRemove, onAdd, isTableView = false }) => {
    const [children, setChildren] = useState([])

    useEffect(() => {
        setChildren(tag.children || [])
    }, [tag])

    return (
        <div className={classNames(styles.tag, { [styles.isTableViewTab]: isTableView })}>
            <div className={classNames(styles.tagMain, { [styles.isSelected]: isTagsExistId(selectedTags, tag.id) })}>
                <MarkList tag={tag} />
                <div className={styles.tagName} title={tag.name}>
                    {tag.name}
                </div>
                <div className={styles.tagActions}>
                    {isTableView ? (
                        <div className={styles.tagAction} title="Remove" onClick={() => onRemove(tag)}>
                            <img src={iconRemove} alt="remove" />
                        </div>
                    ) : (
                        <>
                            {isTagsExistId(selectedTags, tag.id) ? (
                                <div className={styles.tagAction} title="Remove" onClick={() => onRemove(tag)}>
                                    <img src={iconRemove} alt="remove" />
                                </div>
                            ) : (
                                <div className={styles.tagAction} title="Add" onClick={() => onAdd(tag)}>
                                    <img src={iconAdd} alt="add" />
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
            {!!children.length && (
                <ul className={styles.tagChildrenList}>
                    {children.map(childrenTag => (
                        <li
                            key={childrenTag.id}
                            className={classNames(styles.tagChildren, {
                                [styles.isSelected]: isTagsExistId(selectedTags, childrenTag.id),
                            })}
                        >
                            <MarkList tag={childrenTag} isChildren />
                            <div className={styles.tagChildrenName} title={childrenTag.name}>
                                {childrenTag.name}
                            </div>
                            <div className={styles.tagActions}>
                                {isTagsExistId(selectedTags, childrenTag.id) ? (
                                    <div
                                        className={styles.tagAction}
                                        title="Remove"
                                        onClick={() => onRemove(childrenTag)}
                                    >
                                        <img src={iconRemove} alt="remove" />
                                    </div>
                                ) : (
                                    <div className={styles.tagAction} title="Add" onClick={() => onAdd(childrenTag)}>
                                        <img src={iconAdd} alt="add" />
                                    </div>
                                )}
                            </div>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    )
}

const ListView = ({
    tagsList = [],
    selectedTags = [],
    isTableView = false,
    onEdit = () => {},
    onRemove = () => {},
    onAdd = () => {},
    isDisabled,
    isSelectedList = false,
}) => {
    const [tags, setTags] = useState([])

    useEffect(() => {
        if (isSelectedList) {
            const _tags = selectedTags.filter(tag => !tag.parentTag).map(tag => ({ ...tag, children: [] }))
            selectedTags
                .filter(tag => !!tag.parentTag)
                .forEach(selectedChildrenTag => {
                    const parentIndex = _tags.findIndex(parentTag => parentTag.name === selectedChildrenTag.parentTag)
                    if (parentIndex !== -1) _tags[parentIndex].children.push(selectedChildrenTag)
                    else _tags.push(selectedChildrenTag)
                })
            setTags(_tags)
        } else {
            setTags(tagsList)
        }
    }, [tagsList, selectedTags, isSelectedList])

    return (
        <div className={classNames(styles.tags, { [styles.isDisabledTags]: isDisabled })}>
            {isTableView ? (
                <div className={styles.tableView}>
                    <div className={styles.editButton} title="Edit tags" onClick={() => onEdit()}>
                        <img src={editIcon} alt="edit" />
                    </div>
                    {tags.map(tag => (
                        <Item key={tag.id} isTableView selectedTags={selectedTags} tag={tag} onRemove={onRemove} />
                    ))}
                </div>
            ) : (
                <>
                    {!!tags.length ? (
                        <Masonry gutter={'6px'} columnsCount={5} sequential>
                            {tags.map(tag => (
                                <Item
                                    key={tag.id}
                                    selectedTags={selectedTags}
                                    tag={tag}
                                    onRemove={onRemove}
                                    onAdd={onAdd}
                                />
                            ))}
                        </Masonry>
                    ) : (
                        <div className={styles.isEmptyList}>Not selected</div>
                    )}
                </>
            )}
        </div>
    )
}

export default ListView
